import React, { useState } from "react";
import ConfirmDeleteModal from "./ConfirmDeleteModel";

const TpaPermission = ({
  entityName,
  id_340b,
  tpaName,
  submissionRole,
  eligibilityRole,
  handleDelete,
  canUpdate,
}) => {
  const [displayModal, setDisplayModal] = useState(false);

  const vanityRoles = {
    read_only: "Read",
    read_write: "Read and Write",
  };

  function renderDeleteButton() {
    if (canUpdate) {
      return (
        <div className="button button--white button--sq-lg" onClick={() => setDisplayModal(true)}>
          <span className="material-symbols-rounded">delete</span>
        </div>
      );
    }
    return null;
  }

  function formatPermissions() {
    const permissions = [];

    if (eligibilityRole) {
      permissions.push(`${vanityRoles[eligibilityRole]} Eligibility`);
    }

    if (submissionRole) {
      permissions.push(`${vanityRoles[submissionRole]} Submissions`);
    }

    return permissions.join(", ");
  }
  return (
    <div className="tpa__container">
      <div>
        <div className="tpa__name">{tpaName}</div>
        <div className="tpa__permissions">{formatPermissions()}</div>
      </div>
      {renderDeleteButton()}
      {displayModal && (
        <ConfirmDeleteModal
          closeModal={() => setDisplayModal(false)}
          handleDelete={handleDelete}
          id_340b={id_340b}
          entityName={entityName}
          tpaName={tpaName}
        />
      )}
    </div>
  );
};

export default TpaPermission;
